import request from '@/utils/request'

const ClassRizhi = (data) => {
    return request({
        method: 'post',
        data,
        url: '/merchant/v2/class/operate_log',
    })
}

const LeaveRulesRiZhi = (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/leave/operate_log',
        data
    })
}

const TeamRiZhi = (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/group/operate_log',
        data
    })
}

const AddressBookRiZhi = (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/binding/operate_log',
        data
    })
}
export const scheduleOperateLog = (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/schedule/operate_log',
        data
    })
  }
  export const scheduleScoreOperateLog = (data) => {
    return request({
        method: 'post',
        url: '/merchant/v2/schedule_score/operate_log',
        data
    })
  }

  const CheckInRewardsRiZhi = (data) => {
    return request({
      method: 'post',
      url: '/merchant/v2/labor/reward/check_on/operate_log',
      data,
    })
  }
  
  const RecordRewardsRiZhi = (data) => {
    return request({
      method: 'post',
      url: '/merchant/v2/labor/reward/report/operate_log',
      data,
    })
  }
  const TalentOperateLog = (data) => {
    return request({
      method: 'post',
      url: '/merchant/v2/recruitment/talent/operate_log',
      data,
    })
  }
  // 外包相关的操作日志
export  const businessTypeOperateLog = (data) => {
    return request({
      method: 'post',
      url: '/merchant/v2/base/business_type/operate_log',
      data,
    })
  }
export  const enterpriseSealOperateLog = (data) => {
    return request({
      method: 'post',
      url: '/merchant/v2/base/enterprise_seal/operate_log',
      data,
    })
  }
export  const groupCustomerOperateLog = (data) => {
    return request({
      method: 'post',
      url: '/merchant/v2/base/group_customer/operate_log',
      data,
    })
  }
  
export  const customerOperateLog = (data) => {
    return request({
      method: 'post',
      url: '/merchant/v2/base/customer/operate_log',
      data,
    })
  }
export  const projectOperateLog = (data) => {
    return request({
      method: 'post',
      url: '/merchant/v2/base/project/operate_log',
      data,
    })
  }
export  const groupOperateLog = (data) => {
    return request({
      method: 'post',
      url: '/merchant/v2/base/group/operate_log',
      data,
    })
  }
export  const projectContractOperateLog = (data) => {
    return request({
      method: 'post',
      url: '/merchant/v2/base/project_contract/operate_log',
      data,
    })
  }
export  const financeLedgerPeopleOperateLog = (data) => {
    return request({
      method: 'post',
      url: '/merchant/v2/labor/finance_ledger_people/operate_log',
      data,
    })
  }
  
export  const financeLedgerDetailOperateLog = (data) => {
    return request({
      method: 'post',
      url: '/merchant/v2/labor/finance_ledger_detail/operate_log',
      data,
    })
  }
  
  

export default{
    ClassRizhi,
    LeaveRulesRiZhi,
    TeamRiZhi,
    AddressBookRiZhi,
    scheduleOperateLog,
    scheduleScoreOperateLog,
    CheckInRewardsRiZhi,
    RecordRewardsRiZhi,
    TalentOperateLog,
}